import './ccf-check-box-icon.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCheckBoxIconProps  {}
/**
 * component used to display checckbox icon 
 * @param props - CcfCheckBoxIconProps
 * @example - <CcfCheckBoxIcon />
 * @returns SVG of checkbox icon
 */
export function CcfCheckBoxIcon(props: CcfCheckBoxIconProps) {
  return (
    <SvgIcon {...props}>
      <rect
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        rx="1.5"
        fill="white"
        stroke="#dae2e8"
      />
      <path
        d="M9.81353 14.8896L6.96873 11.78L6 12.8315L9.81353 17L18 8.05145L17.0381 7L9.81353 14.8896Z"
        fill="currentcolor"
      />
    </SvgIcon>
  );
}

export default CcfCheckBoxIcon;
